import { __rest } from '../../../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import ModalPortal from '../Modal/Modal.js';
import { EmphasisLM } from '../../../types.js';

/**
Modale per chiedere la conferma di lettura di un messaggio.

Vedi [Design System di CGN - Feedback](https://zeroheight.com/1b5e94371/p/34fc2c-feedback/b/95d71c)

L'icona può essere cambiata specificandone una ma è sempre meglio farlo in accordo con la UX, le icone utilizzabili devono comunque essere "filled".
*/
function FeedbackModal(_a) {
    var { show = false, className = undefined, initialPos = undefined, emphasis = EmphasisLM.MEDIUM } = _a, feedbackProps = __rest(_a, ["show", "className", "initialPos", "emphasis"]);
    return (jsx(ModalPortal, { show: show, className: className, initialPos: initialPos, emphasis: emphasis, children: jsx(ModalPortal.Feedback, Object.assign({ id: "feedbackModal" }, feedbackProps)) }));
}

export { FeedbackModal as default };
